import { connect } from 'react-redux';
import { awardBadge, fetchAvailableBadges } from '../redux/actionCreators';
import { getFragmentsBalance, getCurrentUserHasCore, getCoreLevel } from '../../publicSession/selectors';
import { getAwardModalBadges, getErrorMsg, getIsAwarding } from '../redux/selectors';
const mapStateToProps = (state, ownProps)=>{
    var _getAwardModalBadges;
    return {
        balance: getFragmentsBalance(state),
        badges: (_getAwardModalBadges = getAwardModalBadges(state, ownProps.recipient.user.userId)) !== null && _getAwardModalBadges !== void 0 ? _getAwardModalBadges : [],
        hasCore: getCurrentUserHasCore(state),
        coreLevel: getCoreLevel(state),
        isAwarding: getIsAwarding(state),
        errorMsg: getErrorMsg(state)
    };
};
const mapDispatchToProps = {
    awardBadge,
    fetchAvailableBadges
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=AwardBadgeModal.container.js.map